import { forwardRef } from 'react';
export default function genericComponentFactory(map, defaultKey) {
    var Component = function Component(props, ref) {
        var renderer = props.as ? map[props.as] : map[defaultKey];
        return renderer(props, ref);
    };
    return /*#__PURE__*/ forwardRef(Component);
}

//# sourceMappingURL=genericComponentFactory.js.map